module.exports = __webpack_public_path__ + "img/270-97195d.png";